export const JoinIds = (ids: number[]) => {
    if (!ids || ids.length === 0) {
        return 'undefined';
    }
    else{
        return ids.join(',');
    }
    
};